import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s2_mobile h-100p px-7" }
const _hoisted_4 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s4_mobile h-100p px-2" }
const _hoisted_7 = {
  key: 0,
  class: "text-grey-900 mb-3"
}
const _hoisted_8 = { class: "s3_mobile h-100p px-2" }
const _hoisted_9 = { class: "font-normal mb-5" }
const _hoisted_10 = { class: "s4_mobile h-100p px-3" }
const _hoisted_11 = { class: "font-normal" }
const _hoisted_12 = { class: "text-2xl" }
const _hoisted_13 = { class: "s7_mobile h-100p px-5" }
const _hoisted_14 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}

import { useRoute } from 'vue-router';
    import { computed, inject, ref } from 'vue';
    import { formatAmount, formatDateFrench } from '@/utils';
    import moment from 'moment';
    import UserDecaissementsMensuels from './@components/UserDecaissementsMensuels.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersRevolvingView',
  setup(__props) {

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const startupinfos: any = route.meta.startup_datas;
    const user: any = startupinfos.user;
    const prelevements: any[] = startupinfos.prelevements;
    const loading = ref(false);
    const errorMessage = ref('');

    const quotiteUsedPercent = computed(() => {
        if (!user || !user.quotite_cessible_montant || !user.salaire || user.salaire <= 0) return 0;
        // Si on a une utilisation, on peut la calculer, sinon 0
        // Pour l'instant, on retourne 0 car on n'a pas de données d'utilisation
        return 0;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Membre / Revolving <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Décaissement mensuel</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: !!_unref(user).photo_url ? _unref(user).photo_url : '/assets/users_avatar/600w/user.jpg',
            width: "100%"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_unref(user).kyc?.id)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_7, "n° CF" + _toDisplayString(_unref(user).created_at ? _unref(moment)(_unref(user).created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(_unref(user).kyc.id).padStart(6, '0')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("h4", null, _toDisplayString(_unref(user).nom + ' ' + _unref(user).prenom), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h4", _hoisted_9, _toDisplayString(_unref(user).collectivite?.nom), 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h4", _hoisted_11, [
          _cache[2] || (_cache[2] = _createTextVNode(" Date de fin de souscription ", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
          _createElementVNode("b", _hoisted_12, _toDisplayString(_unref(user).souscription ? _unref(formatDateFrench)(_unref(user).souscription.date_fin) : '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Utilisation", -1)),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
            style: _normalizeStyle({'width': quotiteUsedPercent.value + '%'})
          }, _toDisplayString(quotiteUsedPercent.value) + "% ", 5)
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createVNode(UserDecaissementsMensuels, {
      "user-id": _unref(user).id
    }, null, 8, ["user-id"]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-80" }, null, -1))
  ]))
}
}

})